import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const ListLeaves = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        extra_manpower: "",
        reason:"",
    })


     const [toggle,setToggle]=useState(false);
	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }

    const [department, setDepartmentValue] = useState("");
    const [currentmanpower, setCurrentManPowerValue] = useState("");



  const handleDropdownChange = (event) => {
    
    const value = event.target.value;
    setDepartmentValue(value);
   

    axios.get(API_BASE_URL +'/count_department/'+value, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response => {
    //     console.log(response.data[0].week_count); // Assuming response has a "text" field
    // })

    .then(response => {
        setCurrentManPowerValue(response.data[0].week_count); // Assuming response has a "text" field
    })
    .catch(error => console.error("Error fetching text:", error));

    // Update textbox value based on dropdown selection
   
  };


	


  		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = records.filter((item) =>
			`${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

		const startIndex = (currentPage - 1) * entriesPerPage;
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	 

  useEffect(()=> {
	axios.get(API_BASE_URL +'/showallemployee', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	// .then(res =>console.log(res.data.user_det))
	 .then(res => setData(res.data.user_det))
	.catch(err => console.log(err));
},[])



useEffect(()=> {
	axios.get(API_BASE_URL +'/incharge_manpower_request', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	// .then(res =>console.log(res.data.user_det))
	 .then(res => setRecords(res.data.manpower))
	.catch(err => console.log(err));
},[])












const handleSubmit = async (e) => {
    e.preventDefault();

	// alert(department);
	// alert(currentmanpower);
	// alert(user.extra_manpower);
	// alert(user.reason);
	// setLoading(true);
 

axios.post(API_BASE_URL+'/incharge_request_manpower', { department: department, current_manpower: currentmanpower,extra_manpower:user.extra_manpower,incharge_reason:user.reason }, {
	headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
}).then(response => {
// 	console.log(response.data);
// 	console.log(response.data.message);
// })

var status = response.data.status;

if (status == 200) {
toast.success(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",

});


const timeout = setTimeout(() => {
window.location.reload(); // Reload the current page
}, 5000); // Refresh after 5 seconds

return () => {
clearTimeout(timeout); // Cleanup the timeout if the component unmounts
};

} else if(status == 401) {
toast.error(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",

});
}
else if (status == 400) {
toast.error(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",

});
}


}).catch(error => {
// console.log(error);
// console.log(error.response.data.message);




toast.error(error.response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",


});

});


  };



  // const paginate= (page) => setCurrentPage(page);

	


	useEffect(()=> {
		axios.get(API_BASE_URL +'/head_all_departments', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
	
		//.then(res =>console.log(res.data))
		 .then(res => setdataval(res.data))
		.catch(err => console.log(err));
	},[])


	
	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>


                    

					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
                                                <button style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={()=>setToggle(!toggle)}
                                                        >
                                                            <i className="fe fe-plus mr-2" />
                                                            Add
                                                        </button>
                                                        {toggle && (
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">

                                                      


                                                       


															 <form onSubmit={handleSubmit} > 
					
																<div class="row">
					
																<div className="col-md-4 col-sm-6">
																	<div className="form-group">
                                                                    <label className="form-label">Department <span className="form-required">*</span></label>
																	<select className="form-control show-tick" name="department" value={department} onChange={handleDropdownChange}>
                                                                    <option value="">Select Department</option>
                                                                        {dataval.map((option) => (
                                                                            <option key={option.department_id} value={option.department_id}>
                                                                            {option.department_name} 
                                                                            </option>
                                                                        ))}
																    </select>
																	</div>
																</div>
					
																<div className="col-md-4 col-sm-6">
																	<div className="form-group">
                                                                    <label className="form-label">Current Manpower <span className="form-required">*</span></label>
																	<input type="text" className="form-control" name="currentmanpower" value={currentmanpower}
													readOnly />
																	
																
																	</div>
																</div> 
					
															
					
													</div>

													<div class="row">

													<div className="col-md-4 col-sm-12">
															<div className="form-group">
															
                                                            <label className="form-label">Extra Manpower <span className="form-required">*</span></label>

															<input type="text" className="form-control" name="extra_manpower" value={user.extra_manpower}
								onChange={handelInput}/>
																
															</div>
														</div>



                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                            <label className="form-label">Reason <span className="form-required">*</span></label>

                                                            <textarea
                                                            id="textarea"
                                                            name="reason"
                                                            value={user.reason} // Bind the value to state
                                                            onChange={handelInput} // Update state on change
                                                            placeholder=""
                                                            rows="2" // Number of rows (optional)
                                                            cols="25" // Number of columns (optional)
                                                        ></textarea>
                                                        
                                                        </div>
                                                    </div>
					
														
														
												
					
													
													
					
					
													<div className="col-md-4 col-sm-6">
														<div className="form-group">
					
													<button type="submit" className="btn btn-primary">
													Submit
												</button>
					
												
												</div>
												</div>
					
					
					
												{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
					
												   
					
												<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>
					
												</div>
												</div> */}
					
					
												</div>
					
												
												   
					
															   
					
					
															
						
															
																
															 </form>

                                               
														</div>
													</div>
                                                     )}
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<h3 className="card-title" style={{color:'#e96827'}}></h3>
																<div className="card-options">
																	<form>
																		<div className="input-group">
																		<EntriesSelector style={{
																			padding: '1px',
																			marginRight: '20px',
																			borderRadius: '4px',
																			border: '1px solid #ccc',
																			backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
																		}}
																		setEntriesPerPage={setEntriesPerPage}
																		setCurrentPage={setCurrentPage}
																		/>
																		
																			 <input
																				type="text"
																				className="form-control form-control-sm"
																				placeholder="Search"
																				value={searchTerm}
																				onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}} style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }} 
																			/>
																		</div>
																	</form>
																</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
																		<thead>
																			<tr>
																				
																				<th>Department Name</th>
																				<th>Current Manpower</th>
																				<th>Manpower Requested</th>
																				<th>Reason</th>
																				<th>Date</th>
																				
																				
																			</tr>
																		</thead>
																		<tbody>
																		{records.length > 0 ? (
																				filteredData.map((record) => (
                                                                                  
																					
                                                                                    
                                                               

																					<tr key={record.department_name}>
																					
																					<td>{record.department_name}</td>
																					<td>{record.current_manpower}</td>
																					<td>{record.extra_manpower}</td>
																					<td>{record.incharge_reason}</td>
																					<td>{record.date}</td>
																				
																				</tr>
															   
																				
                                                                                ))
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
											<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>



		




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(ListLeaves);